﻿import { useNavigationModule } from "@agp/shared.user-app/application/context/navigation";
import { useEffect } from "react";
import AnimatedPageTransition from "../../../../../domain/module/navigation/animated-page-transition";

export const MonotoneRootPage = () => {
  const navigation = useNavigationModule();

  useEffect(() => {
    navigation.push("top", {});
  }, [navigation]);

  return <AnimatedPageTransition />;
};
